import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import SectionLayout from 'components/SectionLayout';

import ConcertRubricsCatalog from './components/ConcertRubricsCatalog';
import ConcertsRubrics from './components/ConcertsRubrics';
import ConcertsThematics from './components/ConcertsThematics';
import ConcertsCatalog from './components/ConcertsCatalog';
import ConcertsRecommendationsBlock from './components/ConcertsRecommendationsBlock';

const CommonConcertsTemplate = (props) => {
	const { editorsChoice, concertsOnline, rubrics, themes } = props.blocks;

	return (
		<Layout
			meta={{
				title: 'Концерты онлайн',
				description:
					'Смотреть концерты онлайн и бесплатно, без рекламы и регистрации в хорошем качестве на портале «Культура.РФ».'
			}}
			noCover={_.isEmpty(editorsChoice)}
		>
			<SectionLayout gutter="bottom">
				{!_.isEmpty(editorsChoice) && (
					<ConcertsRecommendationsBlock
						key="editorsChoiceBlock"
						entities={editorsChoice}
					/>
				)}
				{!_.isEmpty(concertsOnline) && (
					<ConcertsCatalog
						key="ConcertsOnlineCatalog"
						concerts={concertsOnline}
					/>
				)}
				{!_.isEmpty(props.rubrics) && (
					<ConcertRubricsCatalog
						key="ConcertRubricsCatalog"
						rubrics={props.rubrics}
					/>
				)}
				{!_.isEmpty(rubrics) && (
					<ConcertsRubrics key="ConcertsRubricsBlock" rubrics={rubrics} />
				)}
				{!_.isEmpty(themes) && (
					<ConcertsThematics key="ConcertsThematicsBlock" themes={themes} />
				)}
			</SectionLayout>
		</Layout>
	);
};

CommonConcertsTemplate.propTypes = {
	blocks: PropTypes.object.isRequired,
	rubrics: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default CommonConcertsTemplate;
